import { render, staticRenderFns } from "./Uploadtest.vue?vue&type=template&id=156e4964&scoped=true&"
import script from "./Uploadtest.vue?vue&type=script&lang=js&"
export * from "./Uploadtest.vue?vue&type=script&lang=js&"
import style0 from "./Uploadtest.vue?vue&type=style&index=0&id=156e4964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156e4964",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
